"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPublicProductProperty = exports.getPublicProductProperties = exports.deleteProductPropertyRelation = exports.postProductPropertyRelation = exports.putProductPropertyOrganization = exports.putProductPropertyAccessibility = exports.deleteProductPropertyPermission = exports.postProductPropertyPermission = exports.postProductProperty = exports.putProductProperty = exports.getProductProperty = exports.getProductProperties = void 0;

var common_1 = require("../common");

var root_1 = require("./root");

var productPropertiesAuthorizedPath = root_1.pimAuthorized + '/ProductProperties/';
var productPropertiesPublicPath = root_1.pimPublic + '/ProductProperties/';

var getProductProperties = function getProductProperties(authentication, queryParameters) {
  return common_1.get(authentication, productPropertiesAuthorizedPath, queryParameters);
};

exports.getProductProperties = getProductProperties;

var getProductProperty = function getProductProperty(authentication, id) {
  return common_1.get(authentication, productPropertiesAuthorizedPath + id);
};

exports.getProductProperty = getProductProperty;

var putProductProperty = function putProductProperty(authentication, ProductProperty) {
  return common_1.put(authentication, productPropertiesAuthorizedPath + ProductProperty.id, ProductProperty);
};

exports.putProductProperty = putProductProperty;

var postProductProperty = function postProductProperty(authentication, ProductProperty) {
  return common_1.post(authentication, productPropertiesAuthorizedPath, ProductProperty);
};

exports.postProductProperty = postProductProperty;

var postProductPropertyPermission = function postProductPropertyPermission(authentication, id, permission) {
  return common_1.postPermission(authentication, productPropertiesAuthorizedPath, id, permission);
};

exports.postProductPropertyPermission = postProductPropertyPermission;

var deleteProductPropertyPermission = function deleteProductPropertyPermission(authentication, id, permissionId) {
  return common_1.deletePermission(authentication, productPropertiesAuthorizedPath, id, permissionId);
};

exports.deleteProductPropertyPermission = deleteProductPropertyPermission;

var putProductPropertyAccessibility = function putProductPropertyAccessibility(authentication, id, accessibility) {
  return common_1.putAccessibility(authentication, productPropertiesAuthorizedPath, id, accessibility);
};

exports.putProductPropertyAccessibility = putProductPropertyAccessibility;

var putProductPropertyOrganization = function putProductPropertyOrganization(authentication, id, accessibility) {
  return common_1.putEntityOrganization(authentication, productPropertiesAuthorizedPath, id, accessibility);
};

exports.putProductPropertyOrganization = putProductPropertyOrganization;

var postProductPropertyRelation = function postProductPropertyRelation(authentication, id, relation) {
  return common_1.postRelation(authentication, productPropertiesAuthorizedPath, id, relation);
};

exports.postProductPropertyRelation = postProductPropertyRelation;

var deleteProductPropertyRelation = function deleteProductPropertyRelation(authentication, id, relationId) {
  return common_1.deleteRelation(authentication, productPropertiesAuthorizedPath, id, relationId);
};

exports.deleteProductPropertyRelation = deleteProductPropertyRelation;

var getPublicProductProperties = function getPublicProductProperties(authentication, queryParameters) {
  return common_1.get(authentication, productPropertiesPublicPath, queryParameters);
};

exports.getPublicProductProperties = getPublicProductProperties;

var getPublicProductProperty = function getPublicProductProperty(authentication, id) {
  return common_1.get(authentication, productPropertiesPublicPath + id);
};

exports.getPublicProductProperty = getPublicProductProperty;